const theme = {
  mediaQuery: {
    desktop: {
      minWidth: '1440px',
    },
    mobile: {
      maxWidth: '1439px',
    },
  },
  palette: {
    primary: {
      main: '#ff4a8b',
      light: '#ff9bbf',
      veryLight: '#ffc9dc',
      pale: '#ffeff5',
    },
    background: {
      main: '#fff',
      gray: '#eee',
      pale: '#fffbfd',
      lightBrown: '#fcfaf7',
    },
    border: {
      main: '#c4c4c4',
      light: '#eee',
    },
    font: {
      main: '#222',
      sub: '#c4c4c4',
      dark: '#000',
      gray: '#999',
      link: '#444',
      light: '#fff',
    },
  },
}

export type Theme = typeof theme
export default theme
